import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
export let EPatientFormTemplateCategory;
(function (EPatientFormTemplateCategory) {
  EPatientFormTemplateCategory["Intake"] = "intake";
  EPatientFormTemplateCategory["Demographics"] = "demographics";
  EPatientFormTemplateCategory["Consent"] = "consent";
  EPatientFormTemplateCategory["Insurance"] = "insurance";
  EPatientFormTemplateCategory["Payment"] = "payment";
})(EPatientFormTemplateCategory || (EPatientFormTemplateCategory = {}));
export let EPatientFormTemplateType;
(function (EPatientFormTemplateType) {
  EPatientFormTemplateType["PreQualification"] = "pre-qualification";
  EPatientFormTemplateType["SchedulerAssist"] = "scheduler-assist";
  EPatientFormTemplateType["Intake"] = "intake";
  EPatientFormTemplateType["Feedback"] = "feedback";
  EPatientFormTemplateType["Ccda"] = "ccda";
})(EPatientFormTemplateType || (EPatientFormTemplateType = {}));
export let EPatientFormTemplateExternalSource;
(function (EPatientFormTemplateExternalSource) {
  EPatientFormTemplateExternalSource["Docusign"] = "docusign";
  EPatientFormTemplateExternalSource["Hellosign"] = "hellosign";
  EPatientFormTemplateExternalSource["Surveymonkey"] = "surveymonkey";
  EPatientFormTemplateExternalSource["Luma"] = "luma";
})(EPatientFormTemplateExternalSource || (EPatientFormTemplateExternalSource = {}));
export let EPatientFormTemplateSource;
(function (EPatientFormTemplateSource) {
  EPatientFormTemplateSource["System"] = "system";
  EPatientFormTemplateSource["User"] = "user";
})(EPatientFormTemplateSource || (EPatientFormTemplateSource = {}));
export let EPatientFormTemplateLumaBotFlow;
(function (EPatientFormTemplateLumaBotFlow) {
  EPatientFormTemplateLumaBotFlow["Welcome"] = "welcome";
  EPatientFormTemplateLumaBotFlow["AuthenticatePatient"] = "authenticate-patient";
  EPatientFormTemplateLumaBotFlow["SpeakWithStaff"] = "speak-with-staff";
  EPatientFormTemplateLumaBotFlow["SessionTimeout"] = "session-timeout";
  EPatientFormTemplateLumaBotFlow["KnockKnock"] = "knock-knock";
  EPatientFormTemplateLumaBotFlow["CulDeSac"] = "cul-de-sac";
  EPatientFormTemplateLumaBotFlow["Feedback"] = "feedback";
  EPatientFormTemplateLumaBotFlow["Default"] = "default";
  EPatientFormTemplateLumaBotFlow["PartialSpeakWithStaff"] = "partial-speak-with-staff";
  EPatientFormTemplateLumaBotFlow["PartialSessionTimeout"] = "partial-session-timeout";
  EPatientFormTemplateLumaBotFlow["PartialKnockKnock"] = "partial-knock-knock";
})(EPatientFormTemplateLumaBotFlow || (EPatientFormTemplateLumaBotFlow = {}));
export let EPatientFormTemplateItemVisibility;
(function (EPatientFormTemplateItemVisibility) {
  EPatientFormTemplateItemVisibility["Default"] = "default";
  EPatientFormTemplateItemVisibility["Hidden"] = "hidden";
  EPatientFormTemplateItemVisibility["Visible"] = "visible";
})(EPatientFormTemplateItemVisibility || (EPatientFormTemplateItemVisibility = {}));
export let EInsuranceCardOptions;
(function (EInsuranceCardOptions) {
  EInsuranceCardOptions["DEFAULT"] = "DEFAULT";
  EInsuranceCardOptions["REQUIRED"] = "REQUIRED";
  EInsuranceCardOptions["OPTIONAL"] = "OPTIONAL";
})(EInsuranceCardOptions || (EInsuranceCardOptions = {}));
export const fieldsPatientFormTemplate = _extends({}, fieldsIBaseModelWithUser, {
  active: {
    type: 'Boolean'
  },
  calculation: {
    type: 'Text'
  },
  category: {
    type: 'Option',
    values: EPatientFormTemplateCategory
  },
  categoryNameToWritebackPDF: {
    type: 'Text'
  },
  checklistCategory: {
    type: 'Option',
    values: EPatientFormTemplateCategory
  },
  description: {
    type: 'Text'
  },
  externalId: {
    type: 'Object'
  },
  finalDispositionCalculation: {
    type: 'Text'
  },
  htmlPdfTemplateBody: {
    type: 'Text'
  },
  htmlPdfTemplateFooter: {
    type: 'Text'
  },
  htmlPdfTemplateHeader: {
    type: 'Text'
  },
  insurance: {
    type: 'Object'
  },
  integratorMapping: {
    type: 'Text'
  },
  lumabot: {
    type: 'Boolean'
  },
  lumaBotFlow: {
    type: 'Option',
    values: EPatientFormTemplateLumaBotFlow
  },
  querystring: {
    type: 'Object'
  },
  questionsForStaffReview: {
    type: 'Object'
  },
  reminder: {
    type: 'Object'
  },
  schedulerRequestInterceptor: {
    type: 'Text'
  },
  schedulerResponseInterceptor: {
    type: 'Text'
  },
  sendToDirectMessageEmail: {
    type: 'Boolean'
  },
  source: {
    type: 'Option',
    values: EPatientFormTemplateSource
  },
  tag: {
    type: 'Text'
  },
  template: {
    type: 'Object'
  },
  title: {
    type: 'Text'
  },
  type: {
    type: 'Option',
    values: EPatientFormTemplateType
  },
  url: {
    type: 'Text'
  },
  writebackOptions: {
    type: 'Unknown'
  }
});